import React from 'react'
import { EmptyState } from '@ketch-com/deck'
import { ReactComponent as EmptyStateAssetIcon } from 'assets/icons/emptyState/EmptyStateAssetTab.svg'

export const NoSearchEmptyState: React.FC = () => (
  <EmptyState
    size="large"
    customIcon={<EmptyStateAssetIcon />}
    title="Lookup an Identity"
    subTitle="Select an identifier and enter a value above to view consent, rights and preferences activity for that individual. You’ll see their full audit trail once a match is found."
    sx={{ justifyContent: 'flex-start', padding: '40px 48px' }}
  />
)
